import { useEffect, useRef, useState } from "react";

/** helpers */
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import useHelper from "@/src/_common/useHelper";

/** MUI */
import { Alert, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ErrorOutline, Autorenew } from "@mui/icons-material";

/** Redux */
import { getScroll, getShowDbStatusBar } from "@/src/_appStore/Common";
import { getPrediction, getPredictionLoading } from "@/src/_appStore/DB_Common";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: theme.shadows[3],
        position: "sticky",
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.palette.primary.main,
        fontWeight: 300,
        zIndex: 1,
        fontSize: "0.77777778rem",
        padding: theme.spacing(0.25, 3),
        display: "flex",
        alignItems: "center",
        // justifyContent: "space-around",
        justifyContent: "start",
        color: "#FFF",
        flexWrap: "wrap",
    },
    rootShort: {
        ...theme.shape.boxedWrapper,
        color: "rgba(0, 0, 0, 0.87)",
        fontWeight: 400,
        fontSize: "0.88888889rem",
        margin: theme.spacing(0, 5, 0, 5),
    },
    rootError: {
        backgroundColor: "rgb(211, 47, 47)",
        color: theme.palette.error.contrastText,
        "&, & *": {
            // color: "#FFF!important",
            // fontSize: "0.77777778rem!important",
        },
    },
    item: {
        display: "inline-flex",
        alignItems: "center",
    },
    label: {
        margin: theme.spacing(0, 1),
    },
    currentValue: {
        margin: theme.spacing(0, 0.5),
        display: "inline-flex",
        alignItems: "center",
    },
    limitValue: {
        margin: theme.spacing(0, 0.5),
    },
    alert: {
        "&, & *": {
            fontSize: "0.77777778rem",
        },
    },

    rotationIcon: {
        animation: "$spin 1s infinite linear",
    },
    [`@keyframes spin`]: {
        "0%": {
            transform: "rotate(0deg)",
        },
        "50%": {
            transform: "rotate(180deg)",
        },
        "100%": {
            transform: "rotate(360deg)",
        },
    },
}));

const StatusBar = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { intlNumberFormat } = useHelper();
    const rootRef = useRef();

    const [SHORT, setSHORT] = useState(false);

    const showDbStatusBar = useSelector(getShowDbStatusBar);
    const prediction = useSelector(getPrediction);
    const predictionLoading = useSelector(getPredictionLoading);
    const appScroll = useSelector(getScroll);

    useEffect(() => {
        if (!rootRef?.current) return;

        const _viewport = window.innerHeight;
        const _bounds = rootRef?.current?.getBoundingClientRect();
        const _trigger = _bounds?.top + _bounds?.height < _viewport;

        setSHORT(_trigger);
    }, [rootRef.current, appScroll, prediction]);

    useEffect(() => {
        const liveRegion = document.getElementById("db-reader-notification");

        if (liveRegion) {
            document.body.removeChild(liveRegion);
        }

        const newLiveRegion = document.createElement("div");
        newLiveRegion.setAttribute("aria-live", "assertive");
        newLiveRegion.id = "db-reader-notification";
        document.body.append(newLiveRegion);
    }, []);

    useEffect(() => {
        const liveRegion = document.getElementById("db-reader-notification");
        liveRegion.setAttribute("aria-hidden", "false");

        while (liveRegion.firstChild) {
            liveRegion.removeChild(liveRegion.firstChild);
        }

        if (!prediction?.table?._accepted) {
            setTimeout(() => {
                liveRegion.insertAdjacentHTML(
                    "afterbegin",
                    prediction?.table?._errMessageShort + prediction?.table?._errMessage
                );
            }, 10);
        }
    }, [prediction]);

    return (
        <>
            {showDbStatusBar && prediction?.table?._complete ? (
                <Box
                    className={clsx(
                        classes.root,
                        SHORT && classes.rootShort,
                        prediction?.table?._accepted || classes.rootError
                    )}
                    ref={rootRef}
                >
                    {prediction?.table?._accepted ? null : (
                        <Box component={"span"} className={classes.item}>
                            {prediction?.table?._errMessageShort}
                        </Box>
                    )}

                    {/* <Box component={"span"} className={classes.item}>
                        <Box className={classes.label} component={"span"}>
                            {t("Kolumny{{colon}}", { colon: ":" })}
                        </Box>
                        <Box
                            className={classes.currentValue}
                            sx={{ fontWeight: prediction?.table?._acceptedInfo?.cols ? "inherit" : 600 }}
                            component={"span"}
                        >
                            {prediction?.table?._acceptedInfo?.cols ? null : (
                                <ErrorOutline sx={{ mt: 0.25, mr: 0.25, fontSize: "1rem", fontWeight: 300 }} />
                            )}

                            {predictionLoading ? (
                                <Autorenew
                                    className={classes.rotationIcon}
                                    sx={{ mt: 0.25, mr: 0.25, fontSize: "1rem", fontWeight: 300 }}
                                />
                            ) : (
                                intlNumberFormat(prediction?.table?.COUNTER?.totalCount || 0, 0)
                            )}
                        </Box>
                        {"/"}
                        <Box className={classes.limitValue} component={"span"}>
                            {intlNumberFormat(prediction?.table?._limits?.columns || 0, 0)}
                        </Box>
                    </Box> */}

                    {/* <Box component={"span"} className={classes.item}>
                        <Box className={classes.label} component={"span"}>
                            {t("Wiersze{{colon}}", { colon: ":" })}
                        </Box>
                        <Box
                            className={classes.currentValue}
                            sx={{ fontWeight: prediction?.table?._acceptedInfo?.rows ? "inherit" : 600 }}
                            component={"span"}
                        >
                            {prediction?.table?._acceptedInfo?.rows ? null : (
                                <ErrorOutline sx={{ mt: 0.25, mr: 0.25, fontSize: "1rem", fontWeight: 300 }} />
                            )}

                            {predictionLoading ? (
                                <Autorenew
                                    className={classes.rotationIcon}
                                    sx={{ mt: 0.25, mr: 0.25, fontSize: "1rem", fontWeight: 300 }}
                                />
                            ) : (
                                intlNumberFormat(prediction?.table?._rowsCount || 0, 0)
                            )}
                        </Box>
                        {"/"}
                        <Box className={classes.limitValue} component={"span"}>
                            {intlNumberFormat(prediction?.table?._limits?.rows || 0, 0)}
                        </Box>
                    </Box> */}

                    <Box component={"span"} className={classes.item}>
                        <Box className={classes.label} component={"span"}>
                            {t("Rekordy{{colon}}", { colon: ":" })}
                        </Box>
                        <Box
                            className={classes.currentValue}
                            sx={{ fontWeight: prediction?.table?._acceptedInfo?.records ? "inherit" : 600 }}
                            component={"span"}
                        >
                            {prediction?.table?._acceptedInfo?.records ? null : (
                                <ErrorOutline sx={{ mt: 0.25, mr: 0.25, fontSize: "1rem", fontWeight: 300 }} />
                            )}

                            {predictionLoading ? (
                                <Autorenew
                                    className={classes.rotationIcon}
                                    sx={{ mt: 0.25, mr: 0.25, fontSize: "1rem", fontWeight: 300 }}
                                />
                            ) : (
                                intlNumberFormat(prediction?.table?._recordsCount || 0, 0)
                            )}
                        </Box>
                        {"/"}
                        <Box className={classes.limitValue} component={"span"}>
                            {intlNumberFormat(prediction?.table?._limits?.records || 0, 0)}
                        </Box>
                    </Box>

                    {/* {prediction?.table?._accepted ? null : (
                        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <Alert
                                severity="error"
                                variant={"filled"}
                                sx={{
                                    width: "100%",
                                    fontSize: 13,
                                    fontWeight: 300,
                                    alignItems: "center",
                                    "&, & .MuiAlert-message, & .MuiAlert-icon": { py: 0 },
                                }}
                            >
                                <Box sx={{ fontSize: 13, mr: 1, fontWeight: 600 }} component={"span"}>
                                    {prediction?.table?._errMessageShort}
                                </Box>
                                {prediction?.table?._errMessage}
                            </Alert>
                        </Box>
                    )} */}
                </Box>
            ) : null}
        </>
    );
};

export default StatusBar;
